// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".navbar[data-v-bb50a5e4] {\n  width: 100%;\n  border-bottom: 1px solid #287ab1;\n}\n.navbar #projetc-title[data-v-bb50a5e4] {\n  background-color: #287ab1;\n  color: #ffffff;\n  font-weight: bold;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
